import React from 'react';
import { NonNegativeNumberInput } from 'components/NonNegativeNumberInput';

interface INumberInputProps {
  label?: string;
  value: string;
  step?: string;
  min?: number;
  max?: number;
  setValue: (val: string | number) => void;
}

const NumberInput = ({
  label,
  value,
  setValue,
  max = 100,
  min = 0,
  step = '1',
}: INumberInputProps) => {
  return (
    <div className="w-full">
      <NonNegativeNumberInput
        value={value}
        step={step}
        className="w-full border border-[#c9cccf] rounded-md px-3 py-2 text-sm text-[#202223] focus:outline-none focus:ring-1 focus:ring-[#2563EB] focus:border-[#2563EB] transition-all bg-white hover:border-[#a6acb3]"
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e: any) => {
          const { value } = e.target;
          if (value > max) {
            e.target.value = max;
          } else if (value < min) {
            e.target.value = min;
          }
          setValue(e.target.value);
        }}
        min={min}
        max={max}
      />
    </div>
  );
};

export default NumberInput;
